import RecordVideo from "../../images/record-video.svg?react";
import RecordAudio from "../../images/record-audio.svg?react";
import RecordScreen from "../../images/record-screen.svg?react";
import RecordWebTraffic from "../../images/record-web-traffic.svg?react";
import detectSidePanel from "../../images/side-panel.svg?react";
import OnlyOneScreen from "../../images/display-check.svg?react";
import DisableNewTab from "../../images/disable-new-tab.svg?react";
import CloseOpenTabs from "../../images/close-open-tabs.svg?react";
import DisableClipboard from "../../images/disable-clipboard.svg?react";
import Whiteboard from "../../images/whiteboard.svg?react";
import Calculator from "../../images/calculator.svg?react";
import DisablePrinting from "../../images/disable-printing.svg?react";
import DisableRightClick from "../../images/disable-right-click.svg?react";
import DisableExtensions from "../../images/disable-extensions.svg?react";
import IdVerification from "../../images/id-check.svg?react";
import RecordClipboard from "../../images/record-clipboard.svg?react";
import RecordKeyboard from "../../images/record-keyboard.svg?react";
import DisableSpellcheck from "../../images/disable-spellcheck.svg?react";
import DisableFileDownload from "../../images/disable-download.svg?react";
import BlockApplications from "../../images/block-applications.svg?react";
import BlockVirtualMachines from "../../images/block-virtual-machines.svg?react";
import RecordAppsActivity from "../../images/record-apps-activity.svg?react";
import FaceDetection from "../../images/face-detection.svg?react";
import ObjectDetection from "../../images/object-detection.svg?react";
import ScanRoom from "../../images/room-scan.svg?react";
import WebsiteAccess from "../../images/website-access.svg?react";
import ScratchNotes from "../../images/scratch-notes.svg?react";
import GuidedAccess from "../../images/guided-access.svg?react";
import RestrictDevices from "../../images/restrict-devices.svg?react";
import RestrictHandoff from "../../images/restrict-handoff.svg?react";
import Signature from "../../images/signatureIcon.svg?react";
import EnableGeofence from "../../images/enable-geofence.svg?react";
import DisableVirtualCamera from "../../images/disable-virtual-camera.svg?react";
import { getUnsupportingPlatforms } from "@verity/proctoring-option";
import { ProctoringOption, ProctoringPlatforms } from "@verity/proctoring-option/types";
import { ReactNode } from "react";
import { Link } from "@mui/material";
import i18nPackage from "../../../i18n/i18n";
import { Trans } from "react-i18next";

export const PROCTORING_OPTION_CATEGORIES = [
	"Record",
	"Verify Identity",
	"Tabs",
	"Disable Features",
	"Restrict Applications",
	"Other Activities",
	"Show Tools",
] as const;

export type ProctoringOptionCategory = (typeof PROCTORING_OPTION_CATEGORIES)[number];

export type ConfigurationPageName =
	| "Third-Party"
	| "Platform"
	| "Configuration"
	| "Method"
	| "Live Sessions"
	| "Accommodations"
	| "Confirmation";

export type StandaloneConfigurationPageName = "Assessment Details" | "Invite Test-Takers";
export type PageIndexNumber = 0 | 1 | 2 | 3 | 4 | 5;

type DisplayPlatform = "extension" | "lockdown" | "mobile" | "chromeOs";

const restrictDevicesDesALabel = i18nPackage.t(
	"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.restrictDevices.descriptionAriaLabel",
);

export const PROCTORING_OPTION_TEXT: {
	[O in keyof ProctoringOption]-?: {
		header: string;
		description: ReactNode;
		icon?: typeof RecordVideo;
		category?: ProctoringOptionCategory;
		settingDescription?: ReactNode;
	};
} = {
	videoRecordingMode: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.videoRecordingMode.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.videoRecordingMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.videoRecordingMode.setting",
		),
		icon: RecordVideo,
		category: "Record",
	},
	audioRecordingMode: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audioRecordingMode.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audioRecordingMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audioRecordingMode.setting",
		),
		icon: RecordAudio,
		category: "Record",
	},
	recordScreen: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.recordScreen.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.recordScreen.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.recordScreen.setting",
		),
		icon: RecordScreen,
		category: "Record",
	},
	scanRoom: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.scanRoom.header"),
		description: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.scanRoom.description"),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.scanRoom.setting",
		),
		icon: ScanRoom,
		category: "Record",
	},
	recordWebTraffic: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordWebTraffic.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordWebTraffic.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordWebTraffic.setting",
		),
		icon: RecordWebTraffic,
		category: "Other Activities",
	},
	detectSidePanel: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.detectSidePanel.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.detectSidePanel.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.detectSidePanel.setting",
		),
		icon: detectSidePanel,
		category: "Other Activities",
	},
	recordInput: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordInput.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordInput.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordInput.setting",
		),
		icon: RecordKeyboard,
		category: "Other Activities",
	},
	recordClipboard: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordClipboard.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordClipboard.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.recordClipboard.setting",
		),
		icon: RecordClipboard,
		category: "Other Activities",
	},
	excludedWebTrafficRecordingUrls: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.excludedWebTrafficRecordingUrls.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.excludedWebTrafficRecordingUrls.description",
		),
		icon: RecordWebTraffic,
		category: "Tabs",
	},

	disableNewTab: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.disableNewTab.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.disableNewTab.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.disableNewTab.setting",
		),
		icon: DisableNewTab,
		category: "Tabs",
	},
	closeOpenTabs: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.closeOpenTabs.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.closeOpenTabs.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.closeOpenTabs.setting",
		),
		icon: CloseOpenTabs,
		category: "Tabs",
	},
	disableClipboardMode: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableClipboardMode.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableClipboardMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableClipboardMode.setting",
		),
		icon: DisableClipboard,
		category: "Disable Features",
	},
	enableGuidedAccessMode: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.enableGuidedAccessMode.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.enableGuidedAccessMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.enableGuidedAccessMode.setting",
		),
		icon: GuidedAccess,
		category: "Disable Features",
	},
	restrictHandoffMode: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.restrictHandoffMode.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.restrictHandoffMode.description",
		),
		settingDescription: (
			<Trans
				i18n={i18nPackage}
				i18nKey={"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.restrictHandoffMode.setting"}
				components={{
					a: (
						<Link
							href="https://support.yuja.com/hc/en-us/articles/35168712896791-Disabling-Handoff-on-Apple-Devices"
							target="_blank"
							rel="noreferrer"
						/>
					),
				}}
			/>
		),
		icon: RestrictHandoff,
		category: "Disable Features",
	},
	disableDownloadFiles: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableDownloadFiles.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableDownloadFiles.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableDownloadFiles.setting",
		),
		icon: DisableFileDownload,
		category: "Disable Features",
	},
	disableSpellcheck: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableSpellcheck.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableSpellcheck.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableSpellcheck.setting",
		),
		icon: DisableSpellcheck,
		category: "Disable Features",
	},
	disablePrinting: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disablePrinting.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disablePrinting.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disablePrinting.setting",
		),
		icon: DisablePrinting,
		category: "Disable Features",
	},
	disableRightClick: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableRightClick.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableRightClick.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableRightClick.setting",
		),
		icon: DisableRightClick,
		category: "Disable Features",
	},
	extensionBlockMode: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.extensionBlockMode.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.extensionBlockMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.extensionBlockMode.setting",
		),
		icon: DisableExtensions,
		category: "Disable Features",
	},
	tabWhiteList: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.tabWhiteList.header"),
		description: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.tabWhiteList.description"),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.tabs.tabWhiteList.setting",
		),
		icon: WebsiteAccess,
		category: "Tabs",
	},
	tabBlockList: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.tabBlockList.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.tabBlockList.description",
		),
		icon: DisableNewTab,
		category: "Disable Features",
	},

	oneScreenEnforcementMode: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.oneScreenEnforcementMode.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.oneScreenEnforcementMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.oneScreenEnforcementMode.setting",
		),
		icon: OnlyOneScreen,
		category: "Other Activities",
	},
	blockVirtualMachines: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.blockVirtualMachines.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.blockVirtualMachines.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.blockVirtualMachines.setting",
		),
		icon: BlockVirtualMachines,
		category: "Restrict Applications",
	},
	applicationBlockMode: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.applicationBlockMode.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.applicationBlockMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.applicationBlockMode.setting",
		),
		icon: BlockApplications,
		category: "Restrict Applications",
	},
	recordApplicationsActivity: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.recordApplicationsActivity.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.recordApplicationsActivity.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.restrictApplications.recordApplicationsActivity.setting",
		),
		icon: RecordAppsActivity,
		category: "Restrict Applications",
	},
	hideOtherWindows: {
		header: "",
		description: "",
	},

	idVerification: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.verifyIdentity.idVerification.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.verifyIdentity.idVerification.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.verifyIdentity.idVerification.setting",
		),
		icon: IdVerification,
		category: "Verify Identity",
	},

	uploadSignature: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.verifyIdentity.uploadSignature.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.verifyIdentity.uploadSignature.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.verifyIdentity.uploadSignature.setting",
		),
		icon: Signature,
		category: "Verify Identity",
	},

	enableCalculator: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.showTools.enableCalculator.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.showTools.enableCalculator.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.showTools.enableCalculator.setting",
		),
		icon: Calculator,
		category: "Show Tools",
	},
	enableWhiteboard: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.showTools.enableWhiteboard.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.showTools.enableWhiteboard.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.showTools.enableWhiteboard.setting",
		),
		icon: Whiteboard,
		category: "Show Tools",
	},

	faceTrackingMode: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.faceTrackingMode.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.faceTrackingMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.faceTrackingMode.setting",
		),
		icon: FaceDetection,
		category: "Record",
	},
	objectDetectionMode: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.record.objectDetectionMode.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.objectDetectionMode.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.objectDetectionMode.setting",
		),
		icon: ObjectDetection,
		category: "Record",
	},

	isExtension: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.plaform.isExtension.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.plaform.isExtension.description",
		),
	},
	isLockdown: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.plaform.isLockdown.header"),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.plaform.isLockdown.description",
		),
	},
	isMobile: {
		header: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.plaform.isMobile.header"),
		description: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.plaform.isMobile.description"),
	},
	isChromeOs: {
		header: "",
		description: "",
	},

	keyboardShortcutBlockList: {
		header: "",
		description: "",
	},
	blockWindowedApplications: {
		header: "",
		description: "",
	},
	applicationBlockList: {
		header: "",
		description: "",
	},
	allowedApplicationsList: {
		header: "",
		description: "",
	},
	allowedExtensionsList: {
		header: "",
		description: "",
	},
	showRecordingPanel: {
		header: "",
		description: "",
	},
	enforceLockdown: {
		header: "",
		description: "",
	},
	enforceMobile: {
		header: "",
		description: "",
	},
	idVerificationEnableAi: {
		header: "",
		description: "",
	},
	quietEnvironment: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audioRecordingMode.quietEnvironmentTitle",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audioRecordingMode.quietEnvironmentDesc",
		),
	},
	uploadScratchNotes: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.uploadScratchNotes.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.uploadScratchNotes.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.uploadScratchNotes.setting",
		),
		icon: ScratchNotes,
		category: "Other Activities",
	},
	idVerificationMode: {
		header: "",
		description: "",
	},
	restrictDevices: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.restrictDevices.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.restrictDevices.description",
		),
		settingDescription: (
			<Trans
				i18n={i18nPackage}
				i18nKey={"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.restrictDevices.setting"}
				components={{
					a: (
						<Link
							href="https://support.yuja.com/hc/en-us/articles/18378524033559-Overview-of-YuJa-Verity-Proctor-Configurations"
							target="_blank"
							rel="noreferrer"
							aria-label={restrictDevicesDesALabel}
						/>
					),
				}}
			/>
		),
		icon: RestrictDevices,
		category: "Other Activities",
	},
	audioTranscription: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audio.audioTranscription.header",
		),
		description: "",
	},
	flaggedKeywords: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.record.audio.flaggedKeywords.header",
		),
		description: "",
	},
	enableGeofence: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.enableGeofence.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.enableGeofence.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.otherActivities.enableGeofence.setting",
		),
		icon: EnableGeofence,
		category: "Other Activities",
	},
	geofenceLocations: {
		header: "",
		description: "",
	},
	disableVirtualCamera: {
		header: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableVirtualCamera.header",
		),
		description: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableVirtualCamera.description",
		),
		settingDescription: i18nPackage.t(
			"editQuizPage.configurationStep.proctoringOptionsTextTSX.disableFeatures.disableVirtualCamera.setting",
		),
		icon: DisableVirtualCamera,
		category: "Disable Features",
	},
};

export function getUnsupportedToggleText<T extends keyof ProctoringOption>(
	proctoringPlatforms: Partial<ProctoringPlatforms>,
	option: T,
	value: ProctoringOption[T],
	toggled: boolean,
) {
	const unsupportingPlatforms = getUnsupportingPlatforms(proctoringPlatforms, option, value);
	const optionHeader = PROCTORING_OPTION_TEXT[option].header;
	const verb =
		unsupportingPlatforms.length > 1
			? i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.do")
			: i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.does");
	const maybeDisabling = toggled ? "disabling " : "";
	const platforms = unsupportingPlatforms.map((x) => PROCTORING_OPTION_TEXT[x].header).join(" and ");

	return unsupportingPlatforms.length > 0
		? i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.unsupportedOptions", {
				platforms,
				verb,
				maybeDisabling,
				option: optionHeader,
			})
		: undefined;
}

export function getOptionsInCategory(proctoringOptionCategory: ProctoringOptionCategory) {
	return Object.entries(PROCTORING_OPTION_TEXT)
		.filter((x) => x[1].category === proctoringOptionCategory && x[1].settingDescription)
		.map((x) => x[0] as keyof ProctoringOption);
}

export function getDisplayedPlatformsFromProctoringOptions(
	options: Partial<Pick<ProctoringOption, "isExtension" | "isLockdown" | "isMobile" | "isChromeOs">>,
): DisplayPlatform[] {
	const platforms: DisplayPlatform[] = [];
	if (options.isExtension) {
		platforms.push("extension");
	}
	if (options.isLockdown) {
		platforms.push("lockdown");
	}
	if (options.isMobile) {
		platforms.push("mobile");
	}
	if (options.isLockdown && options.isChromeOs) {
		platforms.push("chromeOs");
	}
	return platforms;
}

export function getProctoringPlatformName(platform: DisplayPlatform): string {
	return i18nPackage.t(`editQuizPage.configurationStep.proctoringOptionsTextTSX.platform.${platform}`);
}

export function getPlatformTextFromProctoringOptions(
	options: Partial<Pick<ProctoringOption, "isExtension" | "isLockdown" | "isMobile" | "isChromeOs">>,
) {
	const platformText = getDisplayedPlatformsFromProctoringOptions(options).map(getProctoringPlatformName);
	if (platformText.length === 0) {
		return i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.platform.none");
	} else if (platformText.length === 1) {
		return platformText[0];
	} else if (platformText.length === 2) {
		return i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.platform.and2", {
			platform1: platformText[0],
			platform2: platformText[1],
		});
	} else {
		return i18nPackage.t("editQuizPage.configurationStep.proctoringOptionsTextTSX.platform.andMany", {
			platforms: platformText.slice(0, -1).join(", "),
			lastPlatform: platformText[platformText.length - 1],
		});
	}
}
